module.exports = __webpack_public_path__ + "static/img/7.1773422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/7.png
// module id = L0Sy
// module chunks = 0